<template>
  <div
    class="accruals-page-loader"
    :class="{ 'accruals-page-loader--fill': fill }"
    role="status"
    aria-live="polite"
    aria-busy="true"
    :aria-label="loadingLabel"
    data-testid="accruals-brand-loader"
  >
    <div class="accruals-page-loader__header">
      <span
        class="accruals-page-loader__bone accruals-page-loader__bone--title"
        data-testid="accruals-brand-loader__title"
      />
    </div>

    <article
      class="accruals-page-loader__hero"
      data-testid="accruals-brand-loader__hero"
    >
      <span class="accruals-page-loader__bone accruals-page-loader__bone--hero-title" />
      <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
      <span class="accruals-page-loader__bone accruals-page-loader__bone--line accruals-page-loader__bone--line-short" />
      <span class="accruals-page-loader__bone accruals-page-loader__bone--btn" />
    </article>

    <div class="accruals-page-loader__cards">
      <article
        class="accruals-page-loader__card"
        data-testid="accruals-brand-loader__configuration-card"
      >
        <span class="accruals-page-loader__bone accruals-page-loader__bone--card-title" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line accruals-page-loader__bone--line-short" />
      </article>

      <article
        class="accruals-page-loader__card"
        data-testid="accruals-brand-loader__data-card"
      >
        <span class="accruals-page-loader__bone accruals-page-loader__bone--card-title" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line" />
        <span class="accruals-page-loader__bone accruals-page-loader__bone--line accruals-page-loader__bone--line-short" />
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccrualsBrandLoader',
  props: {
    fill: { type: Boolean, default: true },
    loadingLabel: { type: String, default: 'Loading accruals' },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsBrandLoader.scss';
</style>
